import React, { useState } from 'react';
import TutorialModal from '../TutorialsModal/TutorialModal'; // Import your modal component
import TutorialIcon from '../../../../../Assets/images/Tutorial/tutorial.png';
import '../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/Tutorial/TutorialButton.css';



export const TutorialButton: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <div
                className="tutorial_button_container"
                onClick={openModal}
                role="button"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer'
                }}
            >
                <img
                    src={TutorialIcon}
                    alt="Tutorial Icon"
                    style={{ marginRight: '8px' }} // if spacing is needed
                    className="TutorialPng"
                />
                <span className="TutorialText">Tutorials</span>
            </div>
            {isModalOpen && <TutorialModal onClose={closeModal} />}
        </>
    );
};

export default TutorialButton;
